import { Component, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetPromissoryNotesByIdService } from '../../httpServices/get-promissory-notes-by-id.service'
import { ReSendOTPCodeService } from '../../httpServices/re-send-otp-code.service'
import { SignPromissoryNoteService } from '../../httpServices/sign-promissory-note.service'
import { FormGroup, FormControl } from '@angular/forms';
import { HttpClientAuthServiceService } from '../../httpServices/http-client-auth-service.service'
import { AlertasService } from '../../alerta_servicio/alertas.service'

@Component({
  selector: 'app-firma-electronica',
  templateUrl: './firma-electronica.component.html',
  styleUrls: ['./firma-electronica.component.css']
})

export class FirmaElectronicaComponent implements OnInit {
  id: string;
  promiseNotes: any[] = [];
  reSendCode: any[] = [];
  signPromissoryNote_: any[] = [];

  TipoDocumento: string;
  idSolicitud : string;
  idRolFirmante : string;
  idPagare : string;

  public selectedItem : any;
  public codeItem: any;
  public identificationItem: any;
  public pagareItem : any;
  public from : FormGroup;
  public lastId: string;
  public lastTypeId : string;
  public loading : boolean = false;
  public loading_page : boolean = false;
  public myImage : string;

  public showLink : boolean = false;
  

  constructor(private activatedRoute: ActivatedRoute, protected getPromissoryService: GetPromissoryNotesByIdService, 
    protected reSendOTPCodeService: ReSendOTPCodeService, protected signPromissoryNoteService: SignPromissoryNoteService,
    protected httpService: HttpClientAuthServiceService, private alertas:AlertasService, private route: ActivatedRoute) {}

    
  async ngOnInit(): Promise<void> {
    

    this.lastId = "0";
    this.lastTypeId = "0";   
    
    function delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
  }

    await this.httpService.login();
    
    this.route.queryParams.subscribe(params =>{
      this.id = params['token'];
    });

    if(this.id != null)
    {
      this.loading_page = true;
      await delay(3000);
      const splitted = this.id.toString().split("s");
      this.selectedItem = splitted[0];
      this.identificationItem = splitted[1];
      this.codeItem = splitted[2];     
    }
    this.getPromisesNotes();
  }

  getPromisesNotes()
  {
    if(this.selectedItem != null && this.identificationItem != null && 
      (this.selectedItem != this.lastTypeId || this.identificationItem != this.lastId))
    {
      this.loading = true;
      this.loading_page = true;
      this.getPromissoryService.getPromiseNotes_(this.selectedItem,this.identificationItem).subscribe(
        (data) => {
          // Success
          this.promiseNotes = data.body['data'];
          if (this.promiseNotes.length == 1){
            this.pagareItem = this.promiseNotes[0].idSolicitud+"-"+this.promiseNotes[0].idRolFirmante+"-"+this.promiseNotes[0].idPagare;
          }
          this.lastId = this.identificationItem;
          this.lastTypeId = this.selectedItem;      
          this.loading = false;
          localStorage.setItem('pagareBase64',this.promiseNotes[0].contenido);
          this.showLink = true;    
          this.loading_page = false;
        },
        (error) => {
          this.lastId = this.identificationItem;
          this.lastTypeId = this.selectedItem; 
          this.alertas.showError(error.error["message"],"Error obteniendo pagarés");
          localStorage.setItem('pagareBase64',""); 
          this.loading = false;
          this.loading_page = false;
          this.showLink = true; 
        }
      );
    } 
  }

  clickResendCode()
  {
    var splitted = this.pagareItem.toString().split("-");

    
    this.idSolicitud = splitted[0];
    this.idRolFirmante = splitted[1];
    this.idPagare = splitted[2];

    this.reSendOTPCodeService.reSendCode(this.idPagare,this.selectedItem,this.identificationItem,
      this.idRolFirmante,this.idSolicitud).subscribe(
      (data) => {
        // Success
        this.reSendCode = data.body['data'];
        this.alertas.showSuccess("Reenvío de OTP ha sido exitoso","Reenvío del OTP");
      },
      (error) => {
        this.alertas.showError(error.error["message"],"Error en el reenvío del OTP");
      }
    );
  }

  signPromissoryNote()
  {
    var splitted = this.pagareItem.toString().split("-");


    this.idSolicitud = splitted[0];
    this.idRolFirmante = splitted[1];
    this.idPagare = splitted[2];

    this.signPromissoryNoteService.signPromissoryNote(this.idPagare,this.selectedItem,this.identificationItem,
      this.idRolFirmante,this.idSolicitud,this.codeItem).subscribe(
      (data) => {
        // Success
        this.signPromissoryNote_ = data.body['data'];
        this.alertas.showSuccess("La firma se ha realizado exitosamente","Firma del pagaré");
      },
      (error) => {
        this.alertas.showError(error.error["message"],"Error en la firma del documento");
      }
    );
  }

}